import React from "react"

import SEO from "../../../components/seo"
import Layout from "../../../components/layout"
import CustomNavTitle from "../../../components/CustomNavTitle"
import DefaultLayoutSidebar from "../../../components/DefaultLayoutSidebar"

import illustration2x from "../../../images/illustrations/illustration-requirements-et@2x.png"

import { theme } from "../../../styles/theme"

const IntrauterineTransfusion = ({ location }) => {
  return (
    <Layout>
      <SEO title="Specific Requirements - Intrauterine Transfusion (IUT)" />

      <CustomNavTitle
        title="Specific Requirements"
        destination="/requirements/irradiation/"
        location={location}
      />

      <DefaultLayoutSidebar>
        <section className="theme max-w-content">
          <h3 css={[theme.components.title, theme.components.titleRed]}>
            Intrauterine transfusion (IUT)
          </h3>

          <h4
            className="mt-gap-2"
            css={[theme.components.title, theme.components.titleSmall]}
          >
            Indication for irradiated components
          </h4>
          <p>
            All IUTs. Other neonates/infants receiving RBC or platelet
            transfusions where there has been previous IUT. It is recommended
            that red cells are transfused within 24 hours of irradiation.
          </p>

          <h4
            className="mt-gap-2"
            css={[theme.components.title, theme.components.titleSmall]}
          >
            Duration of requirement
          </h4>
          <p>6 months post expected delivery date.</p>
        </section>
        <aside>
          <img src={illustration2x} alt="Illustration" />
        </aside>
      </DefaultLayoutSidebar>
    </Layout>
  )
}

export default IntrauterineTransfusion
